import {config} from "../config";

const FALLBACK_LANG = "en";

class I18nService {
  _translations = {};

  async initTranslations(countryCode: string): Promise<boolean> {
    switch (countryCode) {
        //Austria and Switzerland
      case 'at':
      case 'ch':
        countryCode = 'de';
        break;
    }

    let response = await fetch(`${config.translationPath}/country/${countryCode}/products`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET'
        });
    if (response.ok) {
      let json = await response.json();
      for (let key in json) {
        this._translations[key] = json[key];
      }
    } else {
      if (countryCode === FALLBACK_LANG) {
        return false;
      }
      await this.initTranslations(FALLBACK_LANG);
    }

    return true;
  }

  translate(key: string, ...args: string[]) {
    if (args.length > 0) {
      return this.replaceWildcards(key, args)
    }
    return this._translations[key] ? this._translations[key].toString() : key.toString()
  }


  replaceWildcards(key, array) {
    let translation = this.translate(key);

    if (translation) {
      return translation.replace(/%[0-9]+\$s/g, (wildcard) => {
        let index = parseInt(wildcard.match(/\d+/g));
        return array[index - 1] ? array[index - 1] : wildcard;
      });
    } else
      return false;
  }

}

export let i18nService = new I18nService();